import { owaComputedFn } from 'owa-computed-fn';
import {
    type MailRibbonControlId,
    type MailRibbonGroupId,
    type MailRibbonTabId,
} from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import type { ClientItemId } from 'owa-client-ids';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store/lib/store/store';
import { getDefaultMLRGroupControls } from './getDefaultMLRGroupControls';
import type { ReadOnlyRibbonControlDefProps } from './RibbonControlDefinitionProps';

export const isMLRGroupCustomized: (
    groupId: RibbonGroupId,
    tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => boolean = owaComputedFn(function isMLRGroupCustomized(
    groupId: RibbonGroupId,
    tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): boolean {
    const controlIds = getMailRibbonConfigStore().multiline.homeTab.layout.find(
        g => g.groupId === groupId
    )?.controlIds;
    const defaultControlIds = getDefaultMLRGroupControls(groupId, tabId, props);

    // special handling for the Delete group, since Restore/RestoreAll are not customizable
    // and are prepended to the first group in the layout after the NewMessage group
    if (groupId === 104 && controlIds) {
        const filteredControlIds = controlIds.filter(id => id !== 683 && id !== 684);
        const filteredDefaultControlIds = defaultControlIds.filter(id => id !== 683 && id !== 684);
        return !filteredControlIds.every((id, index) => id === filteredDefaultControlIds[index]);
    }

    if (
        !controlIds || //default group has been removed from the stored ribbon
        controlIds.length !== defaultControlIds.length || // number of controls in the stored group differs from the default
        !controlIds.every((id, index) => id === defaultControlIds[index]) // order of controls differs from the default
    ) {
        return true;
    }
    return false;
});

export const getCustomizedLayoutForGroup = (
    _groupId: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps,
    _itemId: ClientItemId | undefined
) => {
    return undefined; // TODO: implement this function to return the customized layout for the given group based on the ribbon store's layout for that group
};
